import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../../../../components/ui/button';

interface BlogRemoveViewerProps {
  username: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const BlogRemoveViewer: React.FC<BlogRemoveViewerProps> = ({
  username,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog.Root defaultOpen>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-50" />
        <Dialog.Content className="fixed left-1/2 top-1/2 w-[400px]  lg:w-[28vw] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background-main p-6 z-50 text-text-primary">
          <Dialog.Title className="text-xl font-bold mb-4">
            Remove Viewer
          </Dialog.Title>
          <Dialog.Description className=" mb-6">
            Are you sure you want to remove {username} as a viewer from this
            file?
          </Dialog.Description>
          <div className="flex justify-end gap-3">
            <Button
              variant="customSecondary"
              className="bg-secondary"
              size="sm"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              variant="customSecondary"
              className="bg-secondary"
              onClick={() => {
                onConfirm();
              }}
            >
              Remove
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default BlogRemoveViewer;
